// extracted by mini-css-extract-plugin
module.exports = {"day_use_booking_view_wrapper":"BookedDayUseView_day_use_booking_view_wrapper__3SZK8","day_use_icon":"BookedDayUseView_day_use_icon__2QHY5"};